/*
 * Copyright (c) Airbus SAS. All rights reserved.
 */

/**
 * Toggle the mobile menu when a `#header--menu` link is clicked.
 *
 * @type {Listener}
 */
export default {
    selector: '#header--menu a',
    connect(element) {
        const onClick = (e) => {
            e.preventDefault()
            e.stopPropagation()

            document.body.classList.toggle('menu--open')
        }

        element.addEventListener('click', onClick)

        return () => element.removeEventListener('click', onClick)
    },
}
